import React from 'react';
import { Router, Redirect } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { history } from './services/history';

import AuthLayout from './layouts/AuthLayout';
import PainelLayout from './layouts/PainelLayout';
import PdvLayout from './layouts/PdvLayout';

import Login from './pages/Auth/Login';
import PainelVenda from './pages/PainelVenda';
import TelaVenda from './pages/TelaVenda';

const routes = [
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      { path: '/auth/login', exact: true, component: Login },
      { component: () => <Redirect to="/auth/login" /> }
    ]
  },
  {
    path: '/pdv',
    component: PdvLayout,
    routes: [
      { path: '/pdv', exact: true, component: TelaVenda },
      { component: () => <Redirect to="/pdv" /> }
    ]
  },
  {
    path: '/',
    component: PainelLayout,
    routes: [
      { path: '/', exact: true, component: PainelVenda },
      { component: () => <Redirect to="/" /> }
    ]
  },
  { component: () => <Redirect to="/" /> }
];

const Routes = React.memo(() => (
  <Router history={history}>
    {renderRoutes(routes)}
  </Router>
));

export default Routes;